import { memo } from 'react';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClipboardList } from "@fortawesome/free-solid-svg-icons/faClipboardList";
import { selectedDateWithoutTime } from '@store/global/selectors';
import { selectCustomers, selectSelectedCustomerUnvId } from '@pages/orders/store/selectors';
import LoadingElement from 'components/base-elements/loading/LoadingElement';
import CustomerItem from '@pages/orders/customers-page/list-area/customer-item/CustomerItem';



interface ListAreaProps {
	isSmallScreen: boolean,
	pagingLoading: boolean,
}


export const ListArea = (props: ListAreaProps) => {
	const { isSmallScreen, pagingLoading } = props;

	const selectedCustomerUnvId = useSelector(selectSelectedCustomerUnvId);
	const dateWithoutTime = useSelector(selectedDateWithoutTime);
	const customers = useSelector(selectCustomers);


	if (!customers || customers.length === 0) return (
		<div className="list-area">
			<div className="list-area-title">
				<FontAwesomeIcon className="list-area-icon" icon={faClipboardList} />
				<p>Zákazníci</p>
			</div>
			<p className='list-empty'>Žádné záznamy</p>
		</div>
	);

	return (
		<div className="list-area">

			<div className="list-area-title">
				<FontAwesomeIcon className="list-area-icon" icon={faClipboardList} />
				<p>Zákazníci</p>
			</div>
			
			{customers && customers.map(x =>
				<CustomerItem
					item={x}
					dateWithoutTime={dateWithoutTime}
					isSmallScreen={isSmallScreen}
					isSelected={selectedCustomerUnvId && x.orderUnvDestinationId ? selectedCustomerUnvId === x.orderUnvDestinationId : false}
					key={`list-customer-item-${x.orderUnvDestinationId ? x.orderUnvDestinationId : '-'}`} />)}

			{pagingLoading &&
				<LoadingElement />}

		</div>
	)
}

export default memo(ListArea);